import { keepTrackApi } from '@app/keepTrackApi';
import { BaseObject } from '@ootk/src/main';
export class Planet extends BaseObject {
    color = [0.0, 1.0, 0.0, 1.0];
    setHoverDotSize(gl, size) {
        const dotsManagerInstance = keepTrackApi.getDotsManager();
        gl.bindBuffer(gl.ARRAY_BUFFER, dotsManagerInstance.buffers.size);
        gl.bufferSubData(gl.ARRAY_BUFFER, this.id, new Int8Array([size]));
    }
}
